import React from 'react';

const DEFAULT_AVATAR = '/uploads/default.png';

// A missing upload shows the default picture rather than a broken-image icon
const fallBack = (e) => {
  if (e.target.src.indexOf(DEFAULT_AVATAR) === -1) e.target.src = DEFAULT_AVATAR;
};

/*
  The name is the page's title on the public profile (h1); inside the
  dashboard preview it sits under the dashboard's own headings, so it is an
  h2 there. Without a display name the @handle takes its place.
*/
const UserHeader = ({ username, avatar, bio, name, heading: Heading = 'h1' }) => {
  return (
    <header className="userContainer">
      {/* width/height reserve the circle before the image arrives */}
      <img className="avatarStyle" src={avatar} alt="" width="96" height="96" onError={fallBack} />
      <Heading className="userName">{name || `@${username}`}</Heading>
      {name ? <p className="userHandle">@{username}</p> : null}
      {bio ? <p className="userBio">{bio}</p> : null}
    </header>
  )
}

export default UserHeader
